module.exports = __webpack_public_path__ + "img/swap.a2ca3ec4.png";